import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { WhatsOnService } from 'src/app/services/whats-on.service';

/**
 * "Deals" marker for a restaurant card, laid over the corner of its photo. It renders only
 * when the branch has the paid What's On placement, so subscribed restaurants stand out in
 * search results.
 */
@Component({
  selector: 'app-deals-pill',
  standalone: true,
  imports: [NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span *ngIf="visible" class="deals-pill" title="Deals and news in What's On">
    <svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true" focusable="false">
      <path fill="currentColor" fill-rule="evenodd" d="M1.5 2.5a1 1 0 0 1 1-1h4.6a1 1 0 0 1 .7.3l6.4 6.4a1 1 0 0 1 0 1.4l-4.6 4.6a1 1 0 0 1-1.4 0L1.8 7.8a1 1 0 0 1-.3-.7V2.5Zm3 3.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z"/>
    </svg>Deals</span>`,
  styles: [`
    :host { display: inline-flex; flex: none; }
    :host:empty { display: none; }
    .deals-pill {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 2px 8px 2px 7px;
      border-radius: 999px;
      background: #dc2954;
      color: #fff;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      letter-spacing: .02em;
      white-space: nowrap;
      /* Sits on photos: a dark lift keeps it legible on any picture. */
      box-shadow: 0 1px 2px rgba(17, 21, 32, .25), 0 3px 10px -2px rgba(17, 21, 32, .35);
    }
    svg { display: block; flex: none; }
  `]
})
export class DealsPillComponent implements OnChanges, OnDestroy {
  @Input() branchId: number | null | undefined;
  visible = false;
  private subscription?: Subscription;

  constructor(private whatsOn: WhatsOnService, private cdr: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.subscription?.unsubscribe();
    this.visible = false;
    this.subscription = this.whatsOn.watchAvailability(Number(this.branchId)).subscribe(available => {
      this.visible = available;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
